/*
 * GONE.ARCHIVE (3.4) — most miedzy mobilnym <select> a pigulkami dostawcy na karcie produktu.
 * Plik WLASNY: aktualizacja motywu Etheryx go nie nadpisze. Wpiecie: sections/t-product.liquid.
 *
 * Kontekst:
 *   snippets/pdp-variant-picker.liquid renderuje (przy picker_type = "button") dodatkowy
 *   natywny <select data-ga-mobile-option> OBOK <variant-selects>, nie w srodku.
 *   Powod: VariantSelects.selectedOptionValues (assets/t-product.js) zbiera
 *   `select option[selected], fieldset input:checked` z wnetrza <variant-selects> —
 *   drugi picker w srodku dublowalby wartosci dla jednej opcji.
 *
 * Mechanizm:
 *   1. Uzytkownik zmienia <select> (mobile).
 *   2. Znajdujemy w <variant-selects> fieldset odpowiadajacy pozycji opcji i radio o tej wartosci.
 *   3. Ustawiamy radio.checked i wysylamy z niego bubbling 'change'.
 *   4. Dalej dziala ORYGINALNA sciezka motywu: VariantSelects -> publish(optionValueSelectionChange)
 *      -> ProductInfo.renderProductInfo (cena, dostepnosc, media, URL, przycisk Add to cart).
 *   Kierunek odwrotny (klik w pigulke na desktopie) synchronizuje <select>, zeby po zmianie
 *   szerokosci okna oba pickery pokazywaly to samo.
 *
 * Delegacja na document: <variant-selects> jest podmieniane w calosci przy kazdej zmianie
 * wariantu (ProductInfo.updateOptionValues), wiec listenery przypiete do niego by przepadaly.
 */
(function () {
  'use strict';

  var SELECT_SELECTOR = 'select[data-ga-mobile-option]';

  // Kontener obejmujacy oba pickery: <section class="variant-picker"> z pdp-actions.liquid.
  function scopeOf(el) {
    return el.closest('.variant-picker') || el.closest('product-info') || document;
  }

  function fieldsetForPosition(variantSelects, position) {
    var groups = variantSelects.querySelectorAll('fieldset[prod-input]');
    var index = parseInt(position, 10) - 1;
    return index >= 0 && index < groups.length ? groups[index] : null;
  }

  function radioByValue(fieldset, value) {
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) return radios[i];
    }
    return null;
  }

  // <select> (mobile) -> radio dostawcy
  function forwardToRadio(select) {
    var scope = scopeOf(select);
    var variantSelects = scope.querySelector('variant-selects');
    if (!variantSelects) return;

    var fieldset = fieldsetForPosition(variantSelects, select.dataset.optionPosition);
    if (!fieldset) return;

    var radio = radioByValue(fieldset, select.value);
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // radio dostawcy -> <select> (mobile). Bez dispatchu, zeby nie zapetlic.
  function syncSelectFromRadio(radio) {
    var scope = scopeOf(radio);
    var fieldsets = Array.prototype.slice.call(
      scope.querySelectorAll('variant-selects fieldset[prod-input]')
    );
    var position = fieldsets.indexOf(radio.closest('fieldset[prod-input]')) + 1;
    if (position < 1) return;

    var select = scope.querySelector(SELECT_SELECTOR + '[data-option-position="' + position + '"]');
    if (select && select.value !== radio.value) select.value = radio.value;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var select = target.closest(SELECT_SELECTOR);
    if (select) {
      forwardToRadio(select);
      return;
    }

    if (target.tagName === 'INPUT' && target.type === 'radio' && target.closest('variant-selects')) {
      syncSelectFromRadio(target);
    }
  });
})();
